import { GSFormField } from './form-field';

export class GSFormFieldSelect extends GSFormField {

	//
	// Properties
	//

	get type() {
		return 'select';
	}

	get text() {
		return this.input
			.find('option')
			.filter(function() { return this.selected; }) // No :selected in Zepto
			.text().trim();
	}
}
